// Our main CSS
import '../css/app.css'

const applyModules = async () => {
  // Handle reduced motion preferences for ALL videos
  try {
    const allVideos = document.querySelectorAll('video')

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // User prefers reduced motion - remove autoplay from ALL videos
      allVideos.forEach((video) => {
        video.removeAttribute('autoplay')
      })
    } else {
      // User is okay with motion - add autoplay to ALL videos
      allVideos.forEach((video) => {
        video.setAttribute('autoplay', '')
      })
    }

    // Add click to pause/play functionality for all videos
    allVideos.forEach((video) => {
      video.addEventListener('click', function () {
        if (this.paused) {
          this.play()
        } else {
          this.pause()
        }
      })

      // Add keyboard accessibility (spacebar to toggle)
      video.addEventListener('keydown', function (e) {
        if (e.code === 'Space') {
          e.preventDefault()
          if (this.paused) {
            this.play()
          } else {
            this.pause()
          }
        }
      })

      // Make video focusable for keyboard users
      video.setAttribute('tabindex', '0')
    })
  } catch (error) {
    console.error('Error handling video controls:', error)
  }

  // SMOOTH SCROLL EFFECT FOR ANCHOR LINKS
  try {
    const anchorLinks = document.querySelectorAll('a[href*="#"]')

    anchorLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        const href = this.getAttribute('href')
        const hashIndex = href.indexOf('#')

        if (hashIndex !== -1) {
          const hash = href.substring(hashIndex + 1)

          // Skip if it's just a hash without ID or if it's an external link
          if (!hash || href.includes('http')) {
            return
          }

          const targetElement = document.getElementById(hash)

          if (targetElement) {
            e.preventDefault()

            // Check if user prefers reduced motion
            const prefersReducedMotion = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches

            targetElement.scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'start'
            })

            // Auto-open an accordion inside the target (e.g. "Mer information").
            const accordionField = targetElement.querySelector('.accordion-toggle-field')
            if (accordionField) {
              accordionField.checked = true
            }

            // Update URL without causing a page jump
            if (history.pushState) {
              history.pushState(null, null, `#${hash}`)
            }
          }
        }
      })
    })

    // Handle direct hash navigation (e.g., page load with #section)
    window.addEventListener('load', () => {
      if (window.location.hash) {
        const hash = window.location.hash.substring(1)
        const targetElement = document.getElementById(hash)

        if (targetElement) {
          // Small delay to ensure page is fully loaded
          setTimeout(() => {
            const prefersReducedMotion = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches

            targetElement.scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'start'
            })

            const accordionField = targetElement.querySelector('.accordion-toggle-field')
            if (accordionField) {
              accordionField.checked = true
            }
          }, 100)
        }
      }
    })
  } catch (error) {
    console.error('Error loading smooth scroll:', error)
  }

  // Accordions.
  try {
    const accordions = document.querySelectorAll('.accordion')
    accordions.forEach(async (accordion) => {
      const module = await import('./modules/accordion')
      module.default(accordion)
    })
  } catch (error) {
    console.error('Error loading accordions:', error)
  }

  // Breadcrumbs.
  try {
    const breadcrumbs = document.querySelector(
      '.hero-breadcrumbs-full, .hero-breadcrumbs-column, .hero-breadcrumbs-full-dot, .hero-breadcrumbs-full-dot-mobile'
    )
    if (breadcrumbs) {
      const module = await import('./modules/breadcrumbs')
      module.default(breadcrumbs)
    }
  } catch (error) {
    console.error('Error loading breadcrumbs:', error)
  }

  // Focus traps.
  try {
    const focusTraps = document.querySelectorAll('.focus-trap')
    focusTraps.forEach(async (focusTrap) => {
      const module = await import('./modules/focus-trap')
      module.default(focusTrap)
    })
  } catch (error) {
    console.error('Error loading focus trap:', error)
  }

  // Header navigation.
  try {
    const header = document.querySelector('header')
    if (header) {
      const module = await import('./modules/header-navigation')
      module.default(header, {
        revealDuration: 0.5,
        revealEase: 'power2.out',
        hideDuration: 0.25,
        hideEase: 'power2.in',
        switchDuration: 0.25,
        switchEase: 'power2.inOut',
        switchOffset: 50
      })
    }
  } catch (error) {
    console.error('Error loading header navigation:', error)
  }

  // Hero overlay.
  try {
    const hero_overlays = document.querySelectorAll('.hero-overlay-illustration')
    hero_overlays.forEach(async (hero_overlay) => {
      const module = await import('./modules/hero-overlay')
      module.default(hero_overlay)
    })
  } catch (error) {
    console.error('Error loading hero overlay:', error)
  }

  // Hero videos — attach the source only to the visible breakpoint.
  try {
    if (document.querySelector('video[data-defer-video]')) {
      const module = await import('./modules/hero-video')
      module.default(document)
    }
  } catch (error) {
    console.error('Error loading hero video:', error)
  }

  // Carousel swipers.
  try {
    const swipers = document.querySelectorAll('.carousel-swiper')
    swipers.forEach(async (swiper) => {
      const module = await import('./modules/carousel-swiper')
      module.default(swiper)
    })
  } catch (error) {
    console.error('Error loading carousel swipers:', error)
  }

  // Image swipers.
  try {
    const swipers = document.querySelectorAll('.image-swiper')
    swipers.forEach(async (swiper) => {
      const module = await import('./modules/image-swiper')
      module.default(swiper)
    })
  } catch (error) {
    console.error('Error loading image swipers:', error)
  }

  // Sidebar navigation.
  try {
    const sidebar = document.querySelector('.sidebar')
    if (sidebar) {
      const module = await import('./modules/sidebar')
      module.default(sidebar)
    }
  } catch (error) {
    console.error('Error loading sidebar navigation:', error)
  }

  // Table reservation.
  try {
    const reservationCtaButtons = document.querySelectorAll('.btn-book-table')
    reservationCtaButtons.forEach(async (button) => {
      const module = await import('./modules/table-reservation-cta')
      module.default(button)
    })
  } catch (error) {
    console.error('Error loading table reservation CTA:', error)
  }

  // Weather-, track- and lift status.
  try {
    const status = document.querySelectorAll('.status-view')
    status.forEach(async (view) => {
      const module = await import('./modules/status-view')
      module.default(view)
    })
  } catch (error) {
    console.error('Error loading weather status view:', error)
  }

  // Pist status UI.
  try {
    const status = document.querySelectorAll('.pist-status')
    status.forEach(async (view) => {
      const module = await import('./modules/pist-status')
      module.default(view)
    })
  } catch (error) {
    console.error('Error loading pist status view:', error)
  }

  // Tabs view events.
  try {
    const tabs = document.querySelectorAll('.tabs-menu-wrapper')
    tabs.forEach(async (view) => {
      const module = await import('./modules/tabs')
      module.default(view)
    })
  } catch (error) {
    console.error('Error loading tabs view:', error)
  }

  // Rezdy product buttons.
  try {
    const buttons = document.querySelectorAll('.product-action-button')
    buttons.forEach(async (button) => {
      const module = await import('./modules/rezdy-product-overlay')
      module.default(button)
    })
  } catch (error) {
    console.error('Error loading rezdy product buttons:', error)
  }

  // Footer
  try {
    const footer = document.querySelector('footer')
    if (footer) {
      const module = await import('./modules/footer')
      module.default(footer)
    }
  } catch (error) {
    console.error('Error loading footer:', error)
  }

  // Product sticky sidebar
  try {
    const productSidebar = document.getElementById('product-sidebar-sticky')
    if (productSidebar) {
      const module = await import('./modules/product-sticky-sidebar')
      module.default()
    }
  } catch (error) {
    console.error('Error loading product sticky sidebar:', error)
  }

  // Booking hotel widget
  try {
    const bookingWidget = document.getElementById('bookingHotelWidget')
    if (bookingWidget) {
      const module = await import('./modules/booking-hotel-widget')
      module.default(bookingWidget)
    }
  } catch (error) {
    console.error('Error loading booking hotel widget:', error)
  }

  // Alert notifications (fetched via AJAX to bypass page cache)
  try {
    const module = await import('./modules/alert')
    module.default()
  } catch (error) {
    console.error('Error loading alert notifications:', error)
  }

  // Activity-page analytics (LAP-560 AC7). Only loads when the activity
  // template renders its tracking marker.
  try {
    const activityTracking = document.querySelector('.js-activity-tracking')
    if (activityTracking) {
      const module = await import('./modules/activity-tracking')
      module.default(activityTracking)
    }
  } catch (error) {
    console.error('Error loading activity tracking:', error)
  }

  // Activities-listing analytics. Loads only when an activity content block
  // (bookable-activities carousel or product-listing feed) is on the page, so
  // it is effectively scoped to activities pages.
  try {
    const activityBlocks = document.querySelectorAll(
      '[data-block~="bookable-activities"], [data-block~="product-listing"]'
    )
    if (activityBlocks.length) {
      const module = await import('./modules/activities-tracking')
      module.default(activityBlocks)
    }
  } catch (error) {
    console.error('Error loading activities tracking:', error)
  }

  document.body.classList.remove('not-initialized')
  document.body.classList.add('initialized')

  /*
   *  Listen for clicks on the close button in the Rezdy pop-up modal. The button
   *  is not currently working, so we add our own hack version.
   */

  const callback = (e) => {
    if (e.target.matches('.rzd-modal__close')) {
      const modal = e.target.closest('.rzd-modal')
      if (modal) {
        modal.remove()
      }
      // Remove 'overflow: hidden' from html and body elements.
      document.documentElement.style.overflow = ''
      document.body.style.overflow = ''
    }
  }
  const keys = ['Enter', 'Space']
  // Rezdys JS seems to block event bubbling on the click event, so we have to
  // listen for mouseup instead. Sigh...
  document.body.addEventListener('mouseup', callback)
  document.body.addEventListener('keyup', (e) => {
    if (keys.indexOf(e.code) < 0) {
      return
    }
    callback(e)
  })
}

window.addEventListener('CookiebotOnLoad', () => {
  const cookieTrigger = document.getElementById('cookieSettingsTrigger')

  if (!cookieTrigger) {
    return
  }

  cookieTrigger?.addEventListener('click', () => {
    window.Cookiebot.renew()
  })
})

applyModules()
